import React, { useContext, useEffect, useState } from "react";
import { menuContext } from "../../Context/menuContex";
import { Layout } from "../../Components/Layout";
import { Link, useParams } from "react-router-dom";
import { OthersProducts } from "../../Components/OthersProducts";
import { ShoppingCartIcon } from "@heroicons/react/16/solid";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";

export const ItemDetails = () => {
  const { product, toShoppin, setToShoppin, saveToLocalStorage } =
    useContext(menuContext);
  const [totalPrice, setTotalPrice] = useState(0);
  const [productsToShoppin, setProductsToShoppin] = useState([]);
  const [counter, setCounter] = useState(1);
  const [isFlying, setIsFlying] = useState(false);
  const [animateButton, setAnimateButton] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const { id } = useParams();
  const productToShow = product.find((item) => item.id == id);

  productToShow.quantity = counter;
  useEffect(() => {
    setProductsToShoppin([productToShow]);
    setAnimateButton(true);
  }, [productToShow]);
  // Función para calcular el total
  const calculateTotal = () => {
    let total = 0;
    productsToShoppin?.forEach((product) => {
      total += (product?.price ?? 0) * (product?.quantity ?? 1);
    });
    const formattedTotal = total.toLocaleString(undefined, {
      minimumFractionDigits: 0,
    });

    // Asignar el total formateado al estado totalPrice
    setTotalPrice(formattedTotal);
  };
  useEffect(() => {
    calculateTotal();
  }, [productsToShoppin, counter]);

  const handdleClick = () => {
    setIsFlying(true);
    setAnimateButton(false);
    setTimeout(() => {
      if (productsToShoppin.length > 0) {
        const productIndex = toShoppin.findIndex(
          (item) => item.id === productsToShoppin[0].id
        );
        if (productIndex !== -1) {
          /* toShoppin[productIndex].quantity += productsToShoppin[0].quantity;
          setToShoppin([...toShoppin]);
          saveToLocalStorage([...toShoppin]); */
          setShowAlert(true);
          return;
        } else {
          setToShoppin([...toShoppin, ...productsToShoppin]);
          saveToLocalStorage([...toShoppin, ...productsToShoppin]);
        }
        setShowAlert(true);
      }
    }, 1510);
    setTimeout(() => {
      setIsFlying(false);
    }, 1510);
  };
  return (
    <Layout>
      {showAlert && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-10 flex justify-center min-h-full items-center">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[50%] min-w-[300px] max-w-[500px] flex flex-col bg-gray-400 text-white font-semibold text-lg p-2 rounded-lg">
            <span className="text-center">
              El producto ya esta agregado, puedes modificar la cantidad en el
              carrito.
            </span>
            <span className="flex justify-evenly">
              <Link
                to={"/menu"}
                onClick={() => setShowAlert(false)}
                className=" bg-gray-500 p-2 rounded-2xl"
              >
                Seguir comprando
              </Link>
              <Link
                to={"/shoppingcart"}
                onClick={() => setShowAlert(false)}
                className=" bg-gray-500 p-2 rounded-2xl"
              >
                Ver carrito
              </Link>
            </span>
          </div>
        </div>
      )}
      <figure className="w-[80%] self-center rounded-xl">
        <img
          loading="lazy"
          className=" object-contain rounded-xl"
          src={productToShow.images.large}
          alt={productToShow.name}
        />
      </figure>
      <div className=" w-[90%] flex flex-col">
        <span className=" font-light text-xs bg-gray-400 text-white w-fit self-end mt-2 p-1 rounded-lg">
          Papas no incluidas
        </span>

        <h2 className=" font-bold text-2xl self-end">{productToShow.name}</h2>

        <h3 className="font-bold text-lg">Ingredientes:</h3>
        <p className="text-base ml-1">
          {productToShow.ingredients.slice().join(", ")}.
        </p>
        <span className=" flex self-end gap-2 border-[1px] border-gray-300">
          <button
            className=" w-6 text-center font-extrabold border-r-[1px] border-gray-300 bg-gray-200"
            onClick={() => {
              counter !== 1 && setCounter(counter - 1);
            }}
          >
            <MinusIcon className=" text-black " />
          </button>
          <p className="font-semibold text-lg">{counter}</p>
          <button
            className=" w-6  text-center font-extrabold border-r-[1px] border-gray-300 bg-gray-200"
            onClick={() => {
              setCounter(counter + 1);
            }}
          >
            <PlusIcon className=" text-black " />
          </button>
        </span>
      </div>
      <section className="w-[90%] flex flex-col self-center gap-2 pt-2 mb-11">
        {["Adiciones" /* "Bebidas" */].sort().map((categoryName) => (
          <div key={categoryName} className=" flex flex-col gap-2">
            <h2 className="font-bold text-gray-500">{categoryName}</h2>
            {product
              .filter((item) => item.category_Name === categoryName)
              .map((filteredItem) => (
                <OthersProducts
                  item={filteredItem}
                  key={filteredItem.id}
                  productsToShoppin={productsToShoppin}
                  setProductsToShoppin={setProductsToShoppin}
                />
              ))}
          </div>
        ))}
      </section>

      <footer className="bg-[#000000] text-white flex justify-end w-full h-10 z-10 fixed bottom-0">
        <div className="flex justify-items-end p-1">
          <p className="font-semibold text-base  self-center mr-4">
            Este producto: $ {totalPrice}
          </p>
          <span
            className="flex self-center relative cursor-pointer"
            onClick={() => handdleClick()}
          >
            {animateButton && (
              <span
                onClick={(e) => e.stopPropagation()}
                className="absolute inset-0 rounded-full border-solid  border-2 border-gray-300 border-opacity-55 animate-ripple"
              ></span>
            )}
            {animateButton && (
              <span
                onClick={(e) => e.stopPropagation()}
                className="absolute inset-0 rounded-full border-solid  border-2 border-gray-300 border-opacity-55 animate-ripple"
              ></span>
            )}
            <ShoppingCartIcon className=" w-5  self-end pb-1 relative left-1 " />
            <p className=" font-extrabold text-2xl relative  top-[-10px]">+</p>
          </span>
        </div>
      </footer>
      {isFlying && (
        <span className="absolute bottom-5 right-2 animate-fly-heart text-red-500 z-10">
          ❤️
        </span>
      )}
    </Layout>
  );
};
